import Vue from 'vue';
import { EVENT_FILTER_APPLIED } from '../services/event-bus/event-types';
import { getObjectFromSearchParams } from '../services/location-service';

const { eventBus } = window.specialtyApp;
export function useUrlSearchParams(vm) {
    const searchParams = Vue.observable({
        string: '',
        obj: null,
    });

    function update() {
        searchParams.string = window.location.search;
        searchParams.obj = getObjectFromSearchParams(window.location.search.substring(1));
    }

    vm.$on('hook:mounted', () => {
        eventBus.$on(EVENT_FILTER_APPLIED, update);
    });

    vm.$on('hook:destroyed', () => {
        eventBus.$off(EVENT_FILTER_APPLIED, update);
    });

    update();

    return searchParams;
}
